import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { useNextLinkStyles } from '../NextLink';
import { addProtocolIfNeed } from '../../utils/common';

const OuterLink = ({ href, children, className, disabled, rel, startIcon, type, title }) => {
  const classes = useNextLinkStyles();
  const linkTitle = title || (typeof children === 'string' ? children : null);
  return (
    <a
      href={addProtocolIfNeed(href)}
      className={classnames(classes.link, className, {
        [classes.disabled]: disabled,
        [classes.textType]: type === 'text',
        [classes.iconLink]: Boolean(startIcon),
      })}
      target="_blank"
      rel={rel}
      title={linkTitle}
    >
      {startIcon && <span className={classes.iconBox}>{startIcon}</span>}
      {children}
    </a>
  );
};

OuterLink.propTypes = {
  href: PropTypes.string.isRequired,
  children: PropTypes.any,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  rel: PropTypes.string,
  startIcon: PropTypes.element,
  type: PropTypes.oneOf(['text', 'link']),
  title: PropTypes.string,
};

OuterLink.defaultProps = {
  disabled: false,
  rel: 'nofollow',
  type: 'link',
};

export default OuterLink;
